import React from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import "./auto-login-splash.css";

const AutoLoginSplash = ({ isDark, deviceLabel, ipAddress }) => (
  <div className={`auto-login-splash ${isDark ? "auto-login-splash--dark" : "auto-login-splash--light"}`}>
    <div className="auto-login-splash-card">
      <div className="auto-login-splash-icon">
        <ShieldCheck className="w-8 h-8" />
        <span className="auto-login-splash-ring" aria-hidden="true" />
        <span className="auto-login-splash-ring auto-login-splash-ring--delay" aria-hidden="true" />
      </div>
      <h2 className="auto-login-splash-title">Otomatik giriş yapılıyor</h2>
      <p className="auto-login-splash-sub">
        {deviceLabel && ipAddress && ipAddress !== "—" ? (
          <>
            <strong>{ipAddress}</strong> · {deviceLabel}
          </>
        ) : (
          "Kayıtlı cihazınız doğrulanıyor…"
        )}
      </p>
      <div className="auto-login-splash-loader">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span>Lütfen bekleyiniz</span>
      </div>
    </div>
  </div>
);

export default AutoLoginSplash;
